"use strict";

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ShadowContext =
/*#__PURE__*/
function () {
  function ShadowContext() {
    var upstream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var shadows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ShadowContext);

    this.upstream = upstream;
    this.shadows = shadows;
  }

  _createClass(ShadowContext, [{
    key: "getVariable",
    value: function getVariable(name) {
      if (this.shadows.hasOwnProperty(name)) {
        return this.shadows[name];
      }

      return this.upstream.getVariable(name);
    }
  }]);

  return ShadowContext;
}();

exports.ShadowContext = ShadowContext;

var SimpleContext =
/*#__PURE__*/
function () {
  function SimpleContext() {
    _classCallCheck(this, SimpleContext);

    this.variables = {};
  }

  _createClass(SimpleContext, [{
    key: "getVariable",
    value: function getVariable(name) {
      return this.variables[name];
    }
  }]);

  return SimpleContext;
}();

exports.SimpleContext = SimpleContext;

var intrinsics_1 = require("./intrinsics");

var d3_format_1 = require("d3-format");

var parser_1 = require("./parser");

function variableReplacer(map) {
  return function (expr) {
    if (expr instanceof Variable) {
      if (map.hasOwnProperty(expr.name)) {
        return new Variable(map[expr.name]);
      }
    }
  };
}

exports.variableReplacer = variableReplacer;

var Expression =
/*#__PURE__*/
function () {
  function Expression() {
    _classCallCheck(this, Expression);
  }

  _createClass(Expression, [{
    key: "toStringPrecedence",
    value: function toStringPrecedence(parent) {
      if (this.getPrecedence() < parent) {
        return "(".concat(this.toString(), ")");
      } else {
        return this.toString();
      }
    }
  }, {
    key: "getNumberValue",
    value: function getNumberValue(c) {
      var v = this.getValue(c);
      return v;
    }
  }, {
    key: "getStringValue",
    value: function getStringValue(c) {
      var v = this.getValue(c);
      return v.toString();
    }
  }, {
    key: "replace",
    value: function replace(replacer) {
      var r = replacer(this);

      if (r) {
        // If the expression matches the pattern, replace itself
        return r;
      } else {
        // Otherwise, replace any pattern found inside
        return this.replaceChildren(replacer);
      }
    }
  }], [{
    key: "Parse",
    value: function Parse(expr) {
      return parser_1.parse(expr);
    }
  }]);

  return Expression;
}();

exports.Expression = Expression;
/** Text expression is a special class, it cannot be used inside other expression */

var TextExpression =
/*#__PURE__*/
function () {
  function TextExpression() {
    var parts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, TextExpression);

    this.parts = parts;
  }

  _createClass(TextExpression, [{
    key: "getValue",
    value: function getValue(context) {
      return this.parts.map(function (part) {
        if (part.string) {
          return part.string;
        } else if (part.expression) {
          var val = part.expression.getValue(context);

          if (part.format) {
            return d3_format_1.format(part.format)(+val);
          } else {
            return val;
          }
        }
      }).join("");
    }
  }, {
    key: "isTrivialString",
    value: function isTrivialString() {
      return this.parts.every(function (x) {
        return x.string != null;
      });
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.parts.map(function (part) {
        if (part.string) {
          return part.string.replace(/([\$\\])/g, "\\$1");
        } else if (part.expression) {
          var str = part.expression.toString();

          if (part.format) {
            return "${" + str + "}{" + part.format + "}";
          } else {
            return "${" + str + "}";
          }
        }
      }).join("");
    }
  }, {
    key: "replace",
    value: function replace(r) {
      return new TextExpression(this.parts.map(function (part) {
        if (part.string) {
          return {
            string: part.string
          };
        } else if (part.expression) {
          if (part.format) {
            return {
              expression: part.expression.replace(r),
              format: part.format
            };
          } else {
            return {
              expression: part.expression.replace(r)
            };
          }
        }
      }));
    }
  }], [{
    key: "Parse",
    value: function Parse(expr) {
      return parser_1.parse(expr, {
        startRule: "start_text"
      });
    }
  }]);

  return TextExpression;
}();

exports.TextExpression = TextExpression;

var Value =
/*#__PURE__*/
function (_Expression) {
  _inherits(Value, _Expression);

  function Value(value) {
    var _this;

    _classCallCheck(this, Value);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Value).call(this));
    _this.value = value;
    return _this;
  }

  _createClass(Value, [{
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify(this.value);
    }
  }, {
    key: "getPrecedence",
    value: function getPrecedence() {
      return intrinsics_1.precedences.VALUE;
    }
  }, {
    key: "replaceChildren",
    value: function replaceChildren(r) {
      return new Value(this.value);
    }
  }]);

  return Value;
}(Expression);

exports.Value = Value;

var StringValue =
/*#__PURE__*/
function (_Value) {
  _inherits(StringValue, _Value);

  function StringValue() {
    _classCallCheck(this, StringValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(StringValue).apply(this, arguments));
  }

  return StringValue;
}(Value);

exports.StringValue = StringValue;

var NumberValue =
/*#__PURE__*/
function (_Value2) {
  _inherits(NumberValue, _Value2);

  function NumberValue() {
    _classCallCheck(this, NumberValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberValue).apply(this, arguments));
  }

  return NumberValue;
}(Value);

exports.NumberValue = NumberValue;

var BooleanValue =
/*#__PURE__*/
function (_Value3) {
  _inherits(BooleanValue, _Value3);

  function BooleanValue() {
    _classCallCheck(this, BooleanValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(BooleanValue).apply(this, arguments));
  }

  return BooleanValue;
}(Value);

exports.BooleanValue = BooleanValue;

var DateValue =
/*#__PURE__*/
function (_Value4) {
  _inherits(DateValue, _Value4);

  function DateValue() {
    _classCallCheck(this, DateValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(DateValue).apply(this, arguments));
  }

  return DateValue;
}(Value);

exports.DateValue = DateValue;

var FieldAccess =
/*#__PURE__*/
function (_Expression2) {
  _inherits(FieldAccess, _Expression2);

  function FieldAccess(expr, fields) {
    var _this2;

    _classCallCheck(this, FieldAccess);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FieldAccess).call(this));
    _this2.expr = expr;
    _this2.fields = fields;
    return _this2;
  }

  _createClass(FieldAccess, [{
    key: "getValue",
    value: function getValue(c) {
      var v = this.expr.getValue(c);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var f = _step.value;
          v = v[f];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return v;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.expr.toStringPrecedence(intrinsics_1.precedences.FIELD_ACCESS), ".").concat(this.fields.map(Variable.VariableNameToString).join("."));
    }
  }, {
    key: "getPrecedence",
    value: function getPrecedence() {
      return intrinsics_1.precedences.FIELD_ACCESS;
    }
  }, {
    key: "replaceChildren",
    value: function replaceChildren(r) {
      return new FieldAccess(this.expr.replace(r), this.fields);
    }
  }]);

  return FieldAccess;
}(Expression);

exports.FieldAccess = FieldAccess;

var FunctionCall =
/*#__PURE__*/
function (_Expression3) {
  _inherits(FunctionCall, _Expression3);

  function FunctionCall(parts, args) {
    var _this3;

    _classCallCheck(this, FunctionCall);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(FunctionCall).call(this));
    _this3.name = parts.join(".");
    _this3.args = args;
    var v = intrinsics_1.functions;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = parts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var part = _step2.value;

        if (v.hasOwnProperty(part)) {
          v = v[part];
        } else {
          v = undefined;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    if (v == undefined) {
      throw new SyntaxError("undefiend function ".concat(_this3.name));
    } else {
      _this3.function = v;
    }

    return _this3;
  }

  _createClass(FunctionCall, [{
    key: "getValue",
    value: function getValue(c) {
      return this.function.apply(this, _toConsumableArray(this.args.map(function (arg) {
        return arg.getValue(c);
      })));
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.name, "(").concat(this.args.map(function (arg) {
        return arg.toStringPrecedence(intrinsics_1.precedences.FUNCTION_ARGUMENT);
      }).join(", "), ")");
    }
  }, {
    key: "getPrecedence",
    value: function getPrecedence() {
      return intrinsics_1.precedences.FUNCTION_CALL;
    }
  }, {
    key: "replaceChildren",
    value: function replaceChildren(r) {
      return new FunctionCall(this.name.split("."), this.args.map(function (x) {
        return x.replace(r);
      }));
    }
  }]);

  return FunctionCall;
}(Expression);

exports.FunctionCall = FunctionCall;

var Operator =
/*#__PURE__*/
function (_Expression4) {
  _inherits(Operator, _Expression4);

  function Operator(name, lhs, rhs) {
    var _this4;

    _classCallCheck(this, Operator);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Operator).call(this));
    _this4.name = name;
    _this4.lhs = lhs;
    _this4.rhs = rhs;

    if (rhs != undefined) {
      _this4.op = intrinsics_1.operators[name];
    } else {
      _this4.op = intrinsics_1.operators["unary:" + name];
    }

    return _this4;
  }

  _createClass(Operator, [{
    key: "getValue",
    value: function getValue(c) {
      var lhs = this.lhs.getValue(c);

      if (this.rhs != undefined) {
        var rhs = this.rhs.getValue(c);
        return this.op(lhs, rhs);
      } else {
        return this.op(lhs);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      var p = this.getMyPrecedence();

      if (this.rhs != undefined) {
        return "".concat(this.lhs.toStringPrecedence(p[1]), " ").concat(this.name, " ").concat(this.rhs.toStringPrecedence(p[2]));
      } else {
        return "".concat(this.name, " ").concat(this.lhs.toStringPrecedence(p[1]));
      }
    }
  }, {
    key: "getMyPrecedence",
    value: function getMyPrecedence() {
      if (this.rhs != undefined) {
        return intrinsics_1.precedences.OPERATORS[this.name];
      } else {
        return intrinsics_1.precedences.OPERATORS["unary:" + this.name];
      }
    }
  }, {
    key: "getPrecedence",
    value: function getPrecedence() {
      return this.getMyPrecedence()[0];
    }
  }, {
    key: "replaceChildren",
    value: function replaceChildren(r) {
      return new Operator(this.name, this.lhs.replace(r), this.rhs ? this.rhs.replace(r) : null);
    }
  }]);

  return Operator;
}(Expression);

exports.Operator = Operator;

var LambdaFunction =
/*#__PURE__*/
function (_Expression5) {
  _inherits(LambdaFunction, _Expression5);

  function LambdaFunction(expr, argNames) {
    var _this5;

    _classCallCheck(this, LambdaFunction);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(LambdaFunction).call(this));
    _this5.expr = expr;
    _this5.argNames = argNames;
    return _this5;
  }

  _createClass(LambdaFunction, [{
    key: "getValue",
    value: function getValue(c) {
      var _this6 = this;

      return function () {
        var lambdaContext = new ShadowContext(c);

        for (var i = 0; i < _this6.argNames.length; i++) {
          lambdaContext.shadows[_this6.argNames[i]] = i < 0 || arguments.length <= i ? undefined : arguments[i];
        }

        return _this6.expr.getValue(lambdaContext);
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "(".concat(this.argNames.join(", "), ") => ").concat(this.expr.toStringPrecedence(intrinsics_1.precedences.LAMBDA_EXPRESSION));
    }
  }, {
    key: "getPrecedence",
    value: function getPrecedence() {
      return intrinsics_1.precedences.LAMBDA_FUNCTION;
    }
  }, {
    key: "replaceChildren",
    value: function replaceChildren(r) {
      var _this7 = this;

      // Mask the argument variables in the lambda function
      var rMasked = function rMasked(expr) {
        if (expr instanceof Variable && _this7.argNames.indexOf(expr.name) >= 0) {
          return undefined;
        } else {
          return r(expr);
        }
      };

      return new LambdaFunction(this.expr.replace(rMasked), this.argNames);
    }
  }]);

  return LambdaFunction;
}(Expression);

exports.LambdaFunction = LambdaFunction;

var Variable =
/*#__PURE__*/
function (_Expression6) {
  _inherits(Variable, _Expression6);

  function Variable(name) {
    var _this8;

    _classCallCheck(this, Variable);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(Variable).call(this));
    _this8.name = name;
    return _this8;
  }

  _createClass(Variable, [{
    key: "getValue",
    value: function getValue(c) {
      var v = c.getVariable(this.name);

      if (v === undefined) {
        return intrinsics_1.constants[this.name];
      } else {
        return v;
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return Variable.VariableNameToString(this.name);
    }
  }, {
    key: "getPrecedence",
    value: function getPrecedence() {
      return intrinsics_1.precedences.VARIABLE;
    }
  }, {
    key: "replaceChildren",
    value: function replaceChildren(r) {
      return new Variable(this.name);
    }
  }], [{
    key: "VariableNameToString",
    value: function VariableNameToString(name) {
      if (name.match(/^[a-zA-Z_][a-zA-Z0-9_]*$/)) {
        return name;
      } else {
        return JSON.stringify(name).replace(/^\"|\"$/g, "`");
      }
    }
  }]);

  return Variable;
}(Expression);

exports.Variable = Variable;